export default __webpack_public_path__ + "static/media/github.293043cf.svg";